
import { styled } from '@mui/system';
import { Button, Stack, Step, Stepper } from '@mui/material';


const StyledStepperWrapper = styled(Stack, {target: 'StepperWrapper'})(({theme}) => ({
  overflowY: 'hidden',
  overflowX: 'auto',
  minHeight: 'fit-content',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(0,1),
    '@-moz-document url-prefix()': {
      '@media (max-height: 480px)': {
        overflow: 'hidden'
      }
    },
    }
}))

const HeaderNavigation = styled(Stepper, {target: 'Stepper BoxShadow'})(({ theme }) => ({
  padding: theme.spacing(0,1.1),
  width: '100%',
  minHeight: '48px',
  msOverflowStyle: 'none', // IE and Edge
  scrollbarWidth: 'none', // Firefox
  background: '#fff',
  overflow: 'hidden',
  scrollBehavior: 'smooth',
  height: '58px',
  '& .MuiStep-root:focus-visible div': {
    boxShadow: `0px 0px 0px 1px ${theme.vars.palette.primary.main}`
  },
  '& .MuiStepConnector-line': {
    margin: 'auto',
    width: 12,
    [theme.breakpoints.down('sm')]: { width: 6 },
  },
  '& .MuiStepLabel-iconContainer': {
    padding: 0,
    height: '42px',
    width: '42px',
    '& > div': {
      alignItems: 'center'
    }
  },
  '& .MuiStepLabel-iconContainer > div': {
    boxShadow: `0px 1px 4px rgb(${theme.vars.palette.primary.mainChannel} / 0.16)`,
    padding: '0.5em',
    borderRadius: '0.5em'
  },
  //200% accessibility
  [theme.breakpoints.down('sm')]: {
    '&::-webkit-scrollbar': {
      height: '0 !important' // Hide scrollbar for Chrome, Safari and Opera
    },
    overflowX: 'scroll',
    overflowY: 'clip',
   },

}));

const StyledStep = styled(Step)(() => ({
  "&.completed > span": {
    cursor: 'pointer'
  }
}));

const StyledButton = styled(Button)(({ theme }) => ({
  color: `${theme.vars.palette.primary.main}`,
  minWidth: 'unset',
  padding: theme.spacing(0,1,0,1),
  height: '58px',
  '& svg': { fontSize: '0.875rem' },
  '&:hover': {background: '#fff'}
}));

const StyledArrowButtonLeft = styled(StyledButton)(({ theme }) => ({
  borderRadius: theme.spacing(1,0,0,1),
  boxShadow: `0px 1px 8px rgb(var(--mui-palette-primary-mainChannel) / 0.12), 0.5px 0px 1.5px 0px rgb(var(--mui-palette-primary-mainChannel) / 0.12)`,
  // marginLeft: 'auto'
}));

const StyledArrowButtonRight = styled(StyledButton)(({ theme }) => ({
  borderRadius: theme.spacing(0,1,1,0),
  boxShadow: `0px 1px 8px rgb(var(--mui-palette-primary-mainChannel) / 0.12), -0.5px 0px 1.5px 0px rgb(var(--mui-palette-primary-mainChannel) / 0.12)`,
  // marginRight: 'auto'
}));

export { HeaderNavigation, StyledStep, StyledArrowButtonLeft, StyledArrowButtonRight, StyledStepperWrapper }